import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { Mindmap } from '../../components/map/mindmap';
import { MenuBar } from './menu-bar/menu-bar';
import { ToolBar } from './tool-bar/tool-bar';
import { MindmapProvider } from './use-mindmap';

export const MindmapEditor = () => {
  const { id } = useParams();

  if (!id) {
    // or if no mindmap with that id exists
    return <Navigate to="/maps" replace />;
  }

  return (
    <>
      <MindmapProvider id={id}>
        <MenuBar />
        <ToolBar />
        <Mindmap />
      </MindmapProvider>
    </>
  );
};
